import { render, staticRenderFns } from "./HealthWealthSummit2021.vue?vue&type=template&id=e3beb3d0&scoped=true"
import script from "./HealthWealthSummit2021.vue?vue&type=script&lang=js"
export * from "./HealthWealthSummit2021.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3beb3d0",
  null
  
)

export default component.exports